<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded">
<p class="dedf"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>This book is dedicated to the memory of all those patients whose medical condition fostered the study of disease</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Bertoloni-Meli-0006.vue?05e48e65